import {
    apiGet,
    apiPost,
    apiPut,
    apiDelete,
    systemRequestConfig,
} from '@api/api.utils'
import { IResponseCommon, IResponseCommonInsetID } from "@api/common.types"
import { CardUserSendFormType } from './state.types'

import { IResponseCardUser, IResponseUsers } from './api.types'

/** Маршрут на сервер */
const route = '/users'

/** Получение операторов */
export const getUsers = (pageNumber: number, search?: string, isSystemRequest: boolean = false, signal?: AbortSignal): Promise<IResponseUsers> => {
    const config = {params: {pageNumber, search}, signal}
    return apiGet<IResponseUsers>(`${route}/getUsers`, isSystemRequest ? systemRequestConfig(config) : config)
}



/** Получение данных по анкете оператора */
export const getUserCard = (loginID: number, signal?: AbortSignal): Promise<IResponseCardUser> => 
    apiGet<IResponseCardUser>(`${route}/getUserCard`, {params: {loginID}, signal})

/** Создание нового оператора */
export const postUserCard = (data: CardUserSendFormType): Promise<IResponseCommonInsetID> => 
    apiPost<IResponseCommonInsetID>(`${route}/postUserCard`, undefined, {formData: data})

/** Обновление данных по оператору */
export const putUserCard = (loginID: number, data: CardUserSendFormType): Promise<IResponseCommon> => 
    apiPut<IResponseCommon>(`${route}/putUserCard`, {params: {loginID}}, {formData: data})

/** Удаление оператора */
export const deleteUserCard = (loginID: number): Promise<IResponseCommon> => 
    apiDelete<IResponseCommon>(`${route}/deleteUserCard`, {params: {loginID}})

/** Создание допуска к сайту для оператора */
export const postUserAccessSites = (loginID: number, siteID: number): Promise<IResponseCommonInsetID> => 
    apiPost<IResponseCommonInsetID>(`${route}/postUserAccessSites`, {params: {loginID, siteID}})

/** Создание допуска к разделу для оператора */
export const postUserAccessSections = (loginID: number, accessSectionID: number): Promise<IResponseCommonInsetID> => 
    apiPost<IResponseCommonInsetID>(`${route}/postUserAccessSections`, {params: {loginID, accessSectionID}})

/** Удаление допуска к сайту для оператора */
export const deleteUserAccessSites = (loginSiteID: number): Promise<IResponseCommon> => 
    apiDelete<IResponseCommon>(`${route}/deleteUserAccessSites`, {params: {loginSiteID}})

/** Удаление допуска к разделу для оператора */
export const deleteUserAccessSections = (accessID: number): Promise<IResponseCommon> => 
    apiDelete<IResponseCommon>(`${route}/deleteUserAccessSections`, {params: {accessID}})

/** Манипуляции оператора по разделам (чтение, редактирование, удаление) */
export const putUserAccessSectionsChecked = (accessID: number, type: string, isCheked: number): Promise<IResponseCommon> => 
    apiPut<IResponseCommon>(`${route}/putUserAccessSectionsChecked`, {params: {accessID, type, isCheked}})
